import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useRedirect = (fromPath, toPath) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === fromPath) {
      navigate(toPath);
    }
  }, [location, fromPath, toPath, navigate]);
};
